import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a78030f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex preview" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "" }, "Pick up your favorite color ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LTagColor = _resolveComponent("LTagColor")!
  const _component_LUserLink = _resolveComponent("LUserLink")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestedList, (item) => {
        return (_openBlock(), _createBlock(_component_LTagColor, {
          color: item,
          key: item,
          onClick: ($event: any) => (_ctx.handleSetColor(item))
        }, null, 8, ["color", "onClick"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.name)
        ? (_openBlock(), _createBlock(_component_LUserLink, {
            key: 0,
            link: { backgroundColor: _ctx.selectedColor, name: _ctx.name }
          }, null, 8, ["link"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _hoisted_3,
      _createElementVNode("input", {
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.inputColor($event))),
        type: "color",
        name: "",
        id: ""
      }, null, 32)
    ])
  ]))
}